import styled from '@emotion/styled'
import Auth from 'api/Auth'
import opsAnimation from 'assets/plan-expired.json'
import { Box } from 'components'
import { UpgradeModal } from 'components/Modal/Billing/UpgradeModal'
import { SubscriptionChecker } from 'components/SubscriptionChecker'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useUpgradePlanStore } from 'stores/UpgradePlanStore'
import { useUserStore } from 'stores/UserStore'
import { User } from 'types'
import MediaUtils from 'utils/MediaUtils'

const CourtesyPage = () => {
  const user = useUserStore((state) => state.user)

  const forceRedirect = async () => {
    useUpgradePlanStore.getState().setProcessing(true)
    setTimeout(async () => {
      await Auth.loggedUser()
      if (user) {
        const sub = useUserStore.getState().user?.subscription

        const isNotExpired =
          sub &&
          sub?.activePlan &&
          sub?.activePlan?.expirationDate &&
          dayjs(sub.activePlan?.expirationDate).isAfter(dayjs())
        if (isNotExpired) window.location.href = '/'
      }
      useUpgradePlanStore.getState().setProcessing(false)
    }, 1000)
  }

  const courtesyOptions = {
    loop: true,
    animationData: opsAnimation,
    position: -99999999,
  }

  useEffect(() => {
    forceRedirect()
  }, [])

  const CourtesyInterface = () => {
    return (
      <SubscriptionContainer>
        <UpgradeModal logout />
      </SubscriptionContainer>
    )
  }

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        backgroundSize: 'contain',
      }}
    >
      <CourtesyInterface />
    </Box>
  )
}

export default CourtesyPage

const SubscriptionContainer = styled(Box)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center !important;
  align-items: center !important;
  justify-content: left;
  background: url(${MediaUtils.backgrounUrl}) no-repeat center center;
  background-size: cover;
  background-repeat: no-repeat;
  transition: background-image 0.5s ease-in-out;
`
